exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-layout{position:relative;top:10px;left:0;min-width:910px;padding-bottom:20px}", ""]);

// exports
